<template>
  <div class="p-0">
    <div class="row mb-0 pb-0">
      <div class="col-md-12">
       <!--  {{buscadorConFocus}} -->
        <div class="input-group">
          <input
            type="text"
            class="form-control rounded-0 h-50 mi-input"
            :class="{'border-danger' : buscadorConFocus }"
            id="validationDefaultUsername"
            aria-describedby="inputGroupPrepend2"
            v-model="buscarPerroRaza"
            placeholder="Filtrar por raza - variedad - subvariedad....."
            @focus="buscadorConFocus = true"
            ref="inputBuscador"
          />
         
          <!--  @blur="buscadorConFocus = false" -->
          <div class="input-group-prepend">
            <input
              v-show="buscadorConFocus"
              type="submit"
              value="X"
              class="btn btn-sm rounded-0 mi-btn"
              id="inputGroupPrepend2"
              @click.prevent="cancelBuscar"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="buscadorConFocus === true">
      <div class="col-md-12">
        <span class="text-danger" style="font-size:13px;">buscar....</span>
      </div>
    </div>

    <div class="row pt-0 mt-0" v-if="buscadorConFocus === true">
      <div class="col-md-12">
        <table class="table mi-tabla bordered mt-0 mb-0">
          <thead>
            <tr>
              <td>{{$t('Seleccione una raza de la lista')}}</td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for=" (tmp, index) in buscarFiltrado"
              :key="index"
              @click.prevent="seleccionarRaza(tmp.id)"
            >
              <td scope="row">
                <b>{{tmp.name}}</b>
                <span v-if="tmp.variety.trim().length > 0">
                  <br />
                  <span class="text-primary">{{$t('variedad')}}:</span>
                  {{tmp.variety.trim()}}
                </span>
                <span v-if="tmp.subvariety.trim().length > 0">
                  <span class="text-primary">.{{$t('subvariedad')}}:</span>
                  {{tmp.subvariety.trim()}}
                </span>
              </td>
            </tr>
            <tr>
              <td>
                <div class="text-danger pt-2 w-100 text-center">
                  Num registros encontrados:
                  <b>{{numRegFiltro}}</b>
                  Mostrando del {{inicioMostrar + 1}} al {{finMostrar}}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="row mt-2">
          <!-- botones izq -->
          <div class="col-md-3 text-center">
            <button
              class="page"
              :class="{
                  'page-disabled' : paginaActual === 1
                 }"
              :disabled="paginaActual=== 1"
              @click.prevent="moverPagina(0)"
            >
              <b>
                <i class="fa fa-angle-double-left fa-2x"></i>
              </b>
            </button>
            &nbsp;
            <button
              class="page"
              :class="{                  
                  'page-disabled': paginaActual === 1
                 }"
              :disabled="paginaActual === 1"
              @click.prevent="moverPagina(-1)"
            >
              <b>
                <i class="fa fa-angle-left fa-2x"></i>
              </b>
            </button>
          </div>
          <!-- texto paginado -->
          <div class="col-md-6 mx-0 px-0 paginado text-center">
            &nbsp;{{$t('pagina actual')}}: {{paginaActual}} {{$t('de')}} {{maxPages}}&nbsp;
          </div>
          <!-- botones derecha -->
          <div class="col-md-3 text-center">
            <button
              class="page"
              :class="{'page-disabled' : paginaActual >= maxPages}"
              :disabled="paginaActual >= maxPages"
              @click.prevent="moverPagina(1)"
            >
              <b>
                <i class="fa fa-angle-right fa-2x"></i>
              </b>
            </button>
            &nbsp;
            <button
              class="page"
              :class="{                   
                  'page-disabled' : paginaActual >= maxPages
                 }"
              :disabled="paginaActual >= maxPages"
              @click.prevent="moverPagina(maxPages)"
            >
              <b>
                <i class="fa fa-angle-double-right fa-2x"></i>
              </b>
            </button>
          </div>         
        </div>
      </div>
    </div>
    <hr/>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";
export default {
  name: "dog-breeds-search-comp",
  props: ["lista", "selected"],
  data: () => ({
    razaSeleccionada: null,
    buscarPerroRaza: null,
    buscadorConFocus: false,
    paginaActual: 1,
    showPerPage: 10,
    maxPages: 1,
    inicioMostrar: 0,
    finMostrar: 0,
    numRegFiltro: 0

  }),
  methods: {
    pulsarSalir() {
     // alert("has pulsado man");
    },
    seleccionarRaza(id) {
      // console.log("has seleccionado ", id);
      this.$emit("emitDogId", id);
     // this.buscarPerroRaza = null;
    },
    cancelBuscar() {
      this.buscadorConFocus = false;
      this.buscarPerroRaza = null;
      this.$emit("emitCancelarBuscarRaza")
    },
    moverPagina(value) {
      console.log("moverPagina", value);

      if (value === 0) {
        //vamos al inicio
        this.paginaActual = 1;
        return;
      } else if (value === this.maxPages) {
        //vamos al final
        this.paginaActual = this.maxPages;
        return;
      } else {
        //ejecutamos la lógica normal
        this.paginaActual += value;
        if (this.paginaActual < 1) {
          this.paginaActual = 1;
        }
        if (this.paginaActual > this.maxPages && this.paginaActual !== 1) {
          this.paginaActual = this.maxPages;
        }
      }
    }
  },
  computed: {
    razaSelected() {
      if (this.razaSeleccionada !== null) {
        return cloneDeep(this.lista.data.find(p => parseInt(p.id) === this.razaSeleccionada));
      } else {
        return null;
      }
    },
    buscarFiltrado() {
      if (this.lista === null) {
        return;
      }

      if (this.buscarPerroRaza === null) {
        this.buscarPerroRaza = "";
      }

      let filtro = this.buscarPerroRaza.toUpperCase();

      const miFiltro = this.lista.data.filter(x => {
        //hay filtro multiple
        let filtros = [];
        if (filtro.trim().includes("*")) {
          filtros = filtro.trim().split("*");
          filtros = filtros.filter(x => x.trim() !== "");
        }

        if (filtros.length > 1) {
          const raza = filtros.some(f => x.name.toUpperCase().includes(f));
          const variedad = filtros.some(f =>
            x.variety.toUpperCase().includes(f)
          );
          const subVariedad = filtros.some(f =>
            x.subvariety.toUpperCase().includes(f)
          );
          if (raza && variedad && subVariedad) {
            return x;
          }
          if (raza && variedad && !subVariedad) {
            return x;
          }
          if (raza && !variedad && subVariedad) {
            return x;
          }
        } else {
          if (filtros[0] !== undefined) {
            filtro = filtros[0];
          }
          if (
            x.name.toUpperCase().includes(filtro) ||
            x.variety.toUpperCase().includes(filtro) ||
            x.subvariety.toUpperCase().includes(filtro)
          )
            return x;
        }
      });
      this.numRegFiltro = miFiltro.length;
      if (miFiltro.length <= this.showPerPage) {
       // console.log("estoy aquiii no computo nada");
        this.maxPages = 1;
        this.paginaActual = 1;
        return miFiltro;
      } else {
        
        this.maxPages = parseInt(this.numRegFiltro / this.showPerPage);
        let numRegsLastPage = this.numRegFiltro % this.showPerPage;
        if (numRegsLastPage > 0) {
          this.maxPages++;
        }
        //ultimo registro a mostrar dependiendo de la pagina actual
        this.finMostrar = this.paginaActual * this.showPerPage;

        this.inicioMostrar = 0;
        if (this.paginaActual > 1) {
          this.inicioMostrar = this.finMostrar - this.showPerPage;
        }

        //comprobamos que estamos en la ultima pagina y que hay registros sueltos
        if (this.maxPages === this.paginaActual && numRegsLastPage > 0) {
          this.finMostrar = this.inicioMostrar + numRegsLastPage;
          let tmp = miFiltro.slice(this.inicioMostrar, this.numRegFiltro);
          console.log(
            "es lastpage y hay registros sueltos",
            this.inicioMostrar,
            this.inicioMostrar + numRegsLastPage,
            miFiltro,
            tmp
          );
          return tmp;
        } else {
          return miFiltro.slice(this.inicioMostrar, this.finMostrar);
        }
      }
    }
  },
  watch: {
    // Si cambiamos los criterios de busqeuda del filto nos vamos a la pagina 1
    buscarPerroRaza(newValue, oldValue) {      
      this.paginaActual = 1;      
    }
  }, 
  mounted() {   
    console.log(this.lista)
      this.razaSeleccionada = this.selected; 
      this.$refs.inputBuscador.focus();
  }
};
</script>

<style scoped>
span.paginado {
  font-size: 16px !important;
  padding-top: 15px !important;
}
button.page {
  cursor: pointer;
  color: #000;
  min-width: 36px;
  width: 36px;
  height: 36px;
  padding: 0;
  background-color: transparent;

  vertical-align: top;
}
button.page-disabled {
  cursor: not-allowed;
  color: #ccc;
}
a.page-disabled:hover {
  color: #ccc;
}
.input-group-prepend {
  position: absolute;
  right: 2px;
  top: 5%;

  height: 34px !important;
}

.mi-btn {
  min-width: 25px;
  height: 32px;
  width: 30px;
  text-align: center;
  padding: 0;
  z-index: 3 !important;
  background-color: white;
  color: #ccc;
}
.mi-btn:hover {
  color: #000;
}

table.mi-tabla {
  font-size: 0.7em;
  text-align: left;
}
table.mi-tabla td {
  text-align: left;
  height: 35px;
  padding: 0px;
  padding-left: 5px;
  min-height: 35px;
}
table.mi-tabla tbody tr:hover {
  background-color: red;
  color: white;
  font-weight: bold;
  cursor: pointer;
}

div.mi-div {
  /* This bit draws the box around it */
  border: 1px solid grey;
  /* I've used padding so you can see the edges of the elements. */
  padding: 0;
  width: 0%;
  background-color: white;
}
div.mi-div:hover {
  border: 1px solid #000;
}
input.mi-input {
  /* And hide the input's outline, so the form looks like the outline */
  /*  border: none; */
  height: 34px;

  padding: 9px 0px 7px 10px;
  padding-left: 10px;
  background-color: white;
  border: 1px solid #ccc;
}
</style>